import React, { useEffect } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import SearchField from './SearchField';
import { BaseGrid, GridCell } from './Grid';
import Checkbox from './Checkbox';

const StyledBaseGrid = styled(BaseGrid)`
  ${({ maxWidth }) => maxWidth && 'margin: 0 auto;'}
`;

const profileListFiltersPropertyTypes = {
  searchId: PropTypes.string.isRequired,
  searchValue: PropTypes.string,
  searchLabel: PropTypes.string.isRequired,
  searchOnChange: PropTypes.func.isRequired,
  searchOnClear: PropTypes.func.isRequired,
  countryId: PropTypes.string,
  countryValue: PropTypes.string,
  countryOnChange: PropTypes.func,
  allCountriesLabel: PropTypes.string,
  premiumChecked: PropTypes.bool.isRequired,
  premiumOnChange: PropTypes.func.isRequired,
  extraFilters: PropTypes.node,
  maxWidth: PropTypes.number,
  CountryField: PropTypes.elementType,
};

type ProfileListFiltersProperties = InferProps<
  typeof profileListFiltersPropertyTypes
>;

const ProfileListFilters = ({
  searchId,
  searchValue,
  searchLabel,
  searchOnChange,
  searchOnClear,
  countryId,
  countryValue,
  countryOnChange,
  allCountriesLabel,
  CountryField,
  premiumChecked,
  premiumOnChange,
  extraFilters,
  maxWidth,
}: ProfileListFiltersProperties) => {
  const { control, watch } = useForm({
    defaultValues: { country: countryValue },
    shouldUnregister: true,
  });

  const country = watch('country');

  useEffect(() => {
    countryOnChange?.({ target: { value: country } });
  }, [countryOnChange, country]);

  return (
    <StyledBaseGrid
      spacing={2}
      maxWidth={maxWidth ?? undefined}
    >
      <GridCell
        lg={countryId ? 8 : 12}
        padding="16px 0 16px 16px"
      >
        <SearchField
          id={searchId}
          fullWidth
          value={searchValue ?? ''}
          label={searchLabel}
          onChange={searchOnChange}
          onClear={searchOnClear}
        />
      </GridCell>
      { countryId && CountryField && (
      <GridCell
        lg={4}
        padding="16px 0 16px 16px"
      >
        <CountryField
          control={control}
          id={countryId}
          emptyLabel={allCountriesLabel}
          variant="outlined"
          name="country"
          fullWidth
        />
      </GridCell>
      )}
      <GridCell padding="0 0 0 16px">
        <Checkbox
          checked={premiumChecked}
          label="Premium"
          onChange={premiumOnChange}
        />
      </GridCell>
      <GridCell padding="0 0 0 16px">
        {extraFilters}
      </GridCell>
    </StyledBaseGrid>
  );
};

ProfileListFilters.propTypes = profileListFiltersPropertyTypes;

export default ProfileListFilters;
